import React from 'react';
import {useThemeSettings} from "../hooks/useThemeSettings.mjs";
import classnames from "classnames";

const componentClass = 'progressBarLine';

const ProgressBarLine = ({ className, progress }) => {
    const { getSurveyThemeConfigs } = useThemeSettings();
    const { progressBarColor } = getSurveyThemeConfigs();
    const progressValue = Math.round(progress.total);
    const classes = classnames('progressBar', componentClass, className, {
        [`${componentClass}--secondaryColor`]: progressBarColor === 'secondary'
    });

    return  <div role="region" aria-label="Survey progress bar">
                <div className={classes} role="progressbar" aria-valuenow={progress.total || 1} aria-label='Survey progress bar' aria-valuemin="0" aria-valuemax="100">
                    <div className={`${componentClass}__indicator`} style={{paddingLeft:  `${(progress.total || 1) - 6}%`}}>
                        {progressValue}%
                    </div>
                    <div className={`${componentClass}__wrapper`}>
                        <div className={`${componentClass}__status`} style={{width: `${progress.total || 1}%`}}/>
                    </div>
                </div>
            </div>;
};

export default ProgressBarLine;
